import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs/Rx";
import { environment } from "../../../../environments/environment";

// Interfaces
import {
	IService,
	IApplication,
	IState,
	IStateModel,
	IStatesModel,
	ICountriesModel,
	ICountry,
	ICountryModel,
	IError,
	IStepModel,
	IApplicationModel,
	IApplicationsModel,
	IReviewer,
	IReviewerModel,
	IReviewersModel,
	IQuestionModel,
	ILevel_CMSMetadata,
	ILevelStep_CMSMetadata,
	ILevelStepSection_CMSMetadata,
	ILevelStepSectionQuestion_CMSMetadata
} from "../../interfaces";
import { level1_CMS, level2_CMS, level3_CMS } from "../../classes/cms";

@Injectable()
export class CmsService implements IService {
	// implements local variables
	// *

	// implements IService
	name = "CmsService";
	levelmetas: ILevel_CMSMetadata[] = [
		level1_CMS(),
		level2_CMS(),
		level3_CMS()
	];

	CURRENT_STEPCMS_METADATA: ILevelStep_CMSMetadata;

	//LEVEL3

	//level[LEVELNUMBER]_[STEPNAME]_title
	//level[LEVELNUMBER]_[STEPNAME]_subtitle

	//level[LEVELNUMBER]_[STEPNAME]_[GROUPNAME/SECTIONNAME]_title
	//level[LEVELNUMBER]_[STEPNAME]_[GROUPNAME/SECTIONNAME]_description

	test(name, value) {
		console.log("testing", name, value);
	}

	constructor() { }

	//CMS CALLS
	getLevel_CMSMetadata(level: number): ILevel_CMSMetadata {
		let levelcms = this.levelmetas.find(a => a.level_number == level);
		return levelcms;
	}

	getLevelStep_CMSMetadata(
		level: number,
		stepname: string
	): ILevelStep_CMSMetadata {
		let cms_level = this.getLevel_CMSMetadata(level);
		return cms_level
			? cms_level.steps.find(
				a => a.step_name.toLowerCase() == stepname.toLowerCase()
			)
			: null;
	}

	getLevelStepSection_CMSMetadata(
		level: number,
		stepname: string,
		sectionname: string
	): ILevelStepSection_CMSMetadata {
		let cms_step = this.getLevelStep_CMSMetadata(level, stepname);
		return cms_step
			? cms_step.sections.find(
				a => a.name.toLowerCase() == sectionname.toLowerCase()
			)
			: null;
	}

	//utility method to pull a section meta directly from the parent stepmeta
	getSection_CMSMetadata(
		stepcmsmeta: ILevelStep_CMSMetadata,
		sectionname: string
	): ILevelStepSection_CMSMetadata {
		return stepcmsmeta.sections.find(
			a => a.name.toLowerCase() == sectionname.toLowerCase()
		);
	}

	getSectionQuestion_CMSMetadata(
		stepcmsmeta: ILevelStep_CMSMetadata,
		sectionname: string,
		questionname: string
	): ILevelStepSectionQuestion_CMSMetadata {
		let ILevelStepSectionQuestion_CMSMetadata: string = "";
		let sn: ILevelStepSection_CMSMetadata = this.getSection_CMSMetadata(
			stepcmsmeta,
			sectionname
		);
		if (sn) {
			let qns: ILevelStepSectionQuestion_CMSMetadata[] = sn.questions;
			if (qns) {
				return qns.find(a => a.name == questionname);
			}
		}

		return null;
	}

	//CREATE APPLICATION HTML

	CreateApplicationHtml(dApplication: IApplication, dSteps: IStepModel[]) {
		let html_appinfo = this._CreateAppInfoHtml(dApplication);

		let html_stepinfo = this._CreateStepHtml(dApplication, dSteps);

		let html = `${html_appinfo}${html_stepinfo}`;

		let content =
			"<!DOCTYPE html PUBLIC '-//W3C//DTD XHTML 1.0 Strict//EN' 'http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd'><html><head><meta http-equiv='Content-Type' content='text/html;charset=utf-8' /></head><body>" +
			html +
			"</body></html>";

		return content;
	}

	private _CreateAppInfoHtml(dApplication: IApplication) {
		let html = "";

		html += `<section style='padding-bottom: 10px;border-bottom: 1px solid gray;'>`;

		html += `<h1 style='color: #333 !important; font-size: 25px;'>${
			dApplication.ApplicationNumber
			}: ${dApplication.Name} - (Level ${dApplication.Level})</h1>`;

		html += `<div>`;

		html += `<div class="col-xs-6">
				<h2 style='margin-bottom: 5px; color: #333; font-size: 20px;'>Applicant Information</h2>
				<div  style=' color: #0066CC;'>
				<div>${dApplication.Applicant.FirstName} ${
			dApplication.Applicant.LastName
			}</div>
				<div>${
			dApplication.Applicant.Address.Line1
				? dApplication.Applicant.Address.Line1
				: ""
			}</div>
				<div>${
			dApplication.Applicant.Address.Line2
				? dApplication.Applicant.Address.Line2
				: ""
			}</div>
				<div>${
			dApplication.Applicant.Address.City
				? dApplication.Applicant.Address.City
				: ""
			}, ${
			dApplication.Applicant.Address.State
				? dApplication.Applicant.Address.State
				: ""
			} ${
			dApplication.Applicant.Address.PostalCode
				? dApplication.Applicant.Address.PostalCode
				: ""
			}</div>
				<div>${
			dApplication.Applicant.Email.Address
				? dApplication.Applicant.Email.Address
				: ""
			}</div>
				<div>${
			dApplication.Applicant.Position
				? dApplication.Applicant.Position
				: ""
			}</div>
				</div>
			</div>
			<br/>
			<div class="col-xs-6 left">
				<h2 style='margin-bottom: 5px;color: #333;font-size: 20px;'>Program Information</h2>
				<div  style=' color: #0066CC;'>
				<div>${dApplication.Hospital.Name}</div>
				<div>${dApplication.Hospital.Address.Line1}</div>
				<div>${dApplication.Hospital.Address.City}, ${
			dApplication.Hospital.Address.State
			} ${dApplication.Hospital.Address.PostalCode}</div>
				</div>
				</div>
			<div style="clear: both">&nbsp;</div>`;
		html += `</div>`;

		html += `</section>`;
		return html;
	}

	private _CreateStepHtml(dApplication: IApplication, dSteps: IStepModel[]) {
		/*	`<section style='padding-bottom: 10px; border-bottom: 1px solid gray;' *ngFor='let s of dSteps'>
			<h1 style='color: #333 !important; font-size: 30px;'>{{s.Step.Name}}</h1>
			<div style='padding-bottom: 10px;' *ngFor='let q of s.Step?.Questions?.Questions'>
				<div style='color: #333'>{{q.Question.Text}}</div>
				<div style=' color: #0066CC;'>{{q.Question.Answer}}</div>
				<!-- <div style='text-indent: 50px;' *ngIf='q.otherAnswer'>
					<div style=' color: #333'>{{q.otherAnswer.question}}</div>
					<div style=' color: #0066CC;'>{{q.otherAnswer.answer}}</div>
				</div> -->
			</div>
		</section>`*/

		let html = "";
		let s: IStepModel;
		//let q:
		for (let i = 0; i < dSteps.length; i++) {
			s = dSteps[i];
			let stepCMS = this.getLevelStep_CMSMetadata(
				dApplication.Level,
				s.Step.Name
			);

			if (!stepCMS) continue;

			//STEP TITLE
			html += `<h1 style='color: #333 !important; font-size: 30px;'>${
				stepCMS.step_title
				}</h1>`;

			//STEP DESCRIPTION
			if (stepCMS.step_description) {
				html += `<b style='color: #333 !important; font-size: 18px;'>${
					stepCMS.step_description
					}</b><br/><br/>`;
			}

			//QUESTIONS
			let uniqueSections = s.Step.Questions
				? this.GetUniqueSectionsFromCRM(s.Step.Questions.Questions)
				: [];

			for (let j = 0; j < uniqueSections.length; j++) {
				let sectionname = uniqueSections[j];
				let sectionCMS = this.getSection_CMSMetadata(
					stepCMS,
					sectionname
				);
				let sectiontitle = sectionCMS ? sectionCMS.title : "";
				let sectiondesc = sectionCMS ? sectionCMS.description : "";

				html += `<div style='color: #333; font-weight:bold; font-size: 16px;padding-bottom: 5px;'>${sectiontitle}</div>`;
				if (sectiondesc != "") {
					html += `<div style='color: #333'>${sectiondesc}</div>`;
				}

				let qArr = s.Step.Questions.Questions.filter(
					a => a.Question.Detail.Group == sectionname
				);

				qArr = qArr.sort(function (obj1, obj2) {
					// Ascending: first age less than the previous
					return obj1.Question.Order - obj2.Question.Order;
				});

				if (qArr != null && qArr.length > 0) {
					for (let k = 0; k < qArr.length; k++) {
						let qAns = qArr[k].Question;

						//check if there is a cms entry for this qKey
						//***************************************************//
						let qKey = qAns.Key;

						let sectionIndividualAnswerCMS = this.getSectionQuestion_CMSMetadata(
							stepCMS,
							sectionname,
							qKey
						);
						if (sectionIndividualAnswerCMS) {
							html += `<div style='color: #333; font-weight:bold; font-size: 14px;padding-bottom: 5px;'>${
								sectionIndividualAnswerCMS.description
								}</div>`;

							qAns.Answer = this.MapIndexToDataSet(qKey, qAns.Answer, sectionIndividualAnswerCMS.dataSet);


						}

						//***************************************************//

						html += `<div style='padding-bottom: 15px;'>`;

						//Qn Texts ending with _QN are used when we dont want them going into the report but are there just to add a text the questionnaire answer record eg: BestPractices_QN
						if (qAns.Text.endsWith(`_QN`)) {
							qAns.Text = "";
						}

						if (qAns.Text == "Role/Title") {
							html += `<div style='color: #333; font-weight:bold; font-size: 14px;padding-bottom: 5px;'>${
								qAns.Detail.Group
								}</div>`;
						}

						html += `<div style='color: #333'>${
							qAns.Text == "Yes/No" ? "" : qAns.Text
							}</div>`;

						if (qAns.Text == "Yes/No") {
							html += `<div style=' color: #0066CC;'>${
								qAns.Answer ? "Yes" : "No"
								}</div>`;
						} else {
							let ans = qAns.Answer
								? qAns.Answer.startsWith("http")
									? `<a href="${
									qAns.Answer
									}" target="_blank">${qAns.Answer}</a>`
									: qAns.Answer
								: "N/A";

							//if answer is true change it to Yes else  No
							ans = this._formatBooleanResponse(ans);

							html += `<div style=' color: #0066CC;'>${ans}</div>`;
						}

						html += `</div>`;
					}
				}
			}

			// for (let j = 0; j <  s.Step.Questions.Questions.length; j++) {

			// 	let q = s.Step.Questions.Questions[j];

			// 	html += `<div style='padding-bottom: 10px;'>
			// 	<div style='color: #333'>{{q.Question.Text}}</div>
			// 	<div style=' color: #0066CC;'>{{q.Question.Answer}}</div>
			// 	</div>`

			// }

			html += `<hr/>`;
		}

		return html;
	}

	MapIndexToDataSet(qkey: string, answer: any, dataset: any) {
		var qkeys = ['stateclassification', 'edbeds', 'edvisits', 'interestedwhy', 'level1_Leadership_GEDOps_radio']
		if (qkeys.indexOf(qkey) > -1 && answer) {
			answer = dataset.filter(a => a.Value == answer)[0].Key
		}

		return answer;
	}

	GetUniqueSectionsFromCRM(qArr: IQuestionModel[]) {
		let uniqueSections = [];

		qArr = qArr.sort(function (obj1, obj2) {
			// Ascending: first age less than the previous
			return obj1.Question.Order - obj2.Question.Order;
		});

		for (let i = 0; i < qArr.length; i++) {
			let groupname = qArr[i].Question.Detail.Group;
			if (uniqueSections.indexOf(groupname) == -1) {
				uniqueSections.push(groupname);
			}
		}

		return uniqueSections;
	}

	private _formatBooleanResponse(ans: string) {
		if (ans == "true") {
			ans = "Yes";
		} else if (ans == "false") {
			ans = "No";
		}

		return ans;
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/cms/cms.service.ts